import { createStore, withProps } from "@ngneat/elf";
import { GlobalStatistics } from "@store/globalStatistics/globalStatistics.model";
import { withRequestsStatus } from "@ngneat/elf-requests";

export const globalStatisticsStore = createStore(
  { name: "global-statistics" },
  withProps<GlobalStatistics>({filters: {}}),
  withRequestsStatus()
);
